export default __webpack_public_path__ + "static/gynoveda-a329fda3b99db247c223eaf0a26e295c.png";